import React from 'react';
import { Avatar } from 'antd';

import { getDateFromNow } from 'utils/dateUtils';
import { MemberCommentViewModel } from 'api/adminApiClient';
import { getAvatarContent, getFullName } from 'utils/personUtils';

import style from './CommentCard.module.less';

type Props = {
  comment: MemberCommentViewModel;
};

export default function CommentPost(props: Props) {
  const { comment } = props;
  const { id, firstName, lastName, text, createdDate } = comment;

  return (
    <div className={style.commentCard} data-id={id}>
      <Avatar className={style.avatar} size={24}>
        {getAvatarContent(firstName, lastName)}
      </Avatar>

      <div>
        <div className={style.postHeader}>
          <span>{getFullName(firstName, lastName)}</span>

          {createdDate && (
            <span className={style.createdDate}>
              {getDateFromNow(createdDate)}
            </span>
          )}
        </div>

        <div className={style.text}>{text}</div>
      </div>
    </div>
  );
}
